import { useContext, useEffect, useState, Fragment } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import {
    HomeIcon,
    UserPlusIcon,
    UserIcon,
    IdentificationIcon,
    ShieldCheckIcon,
    UserGroupIcon,
    TruckIcon,
    CalendarDaysIcon,
    ClipboardDocumentCheckIcon,
    BriefcaseIcon,
    BookOpenIcon,
    BookmarkSquareIcon,
    CalendarIcon,
    ShoppingCartIcon,
    PlusCircleIcon,
    UsersIcon,
    TicketIcon,
    Squares2X2Icon,
    StarIcon,
    BookmarkIcon,
    DocumentTextIcon,
    BuildingOffice2Icon,
    ClipboardDocumentListIcon,
    DocumentDuplicateIcon,
    Cog6ToothIcon,
    FlagIcon,
    ArrowRightStartOnRectangleIcon,
    Bars3Icon,
    XMarkIcon,
    ChevronDownIcon,
    Bars3BottomLeftIcon,
    AcademicCapIcon,
    ChatBubbleLeftRightIcon,
    ChatBubbleBottomCenterTextIcon
} from '@heroicons/react/24/solid';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../UserContext';
import { checkPermiso } from '../../Utils/PermissionsFunctions';
import axios from '../../axios';
import './menuLeft.css';
import { sub } from 'date-fns';

const MenuLeft = (props) => {
    const {colapsed, setColapsed, setWContainerAdmin, setWMenuLateral} = props;
    const {user,setUser,setAuth} = useContext(UserContext);
    const [routes,setRoutes] = useState([])
    const [loaded,setLoaded] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [permisos,setPermisos] = useState({
        users_read:null,
        doctors_read:null,
        visits_read:null,
        employees_read:null,
        employee_vacations_history:null,
        appointment_models_list_read:null,
        appointments_list_read:null,
        products_read:null,
        categories_read:null,
        sucursals_read:null,
        doctor_specialties_read:null,
        doctor_institutions_read:null,
        deliveries_read:null,
        suppliers_read:null,
        employee_types_read:null,
        configs_countries_module:null,
        orders_read:null,
        orders_create:null,
        patient_read:null,
        coupons_read:null,
        reportes_read:true,
        whatsapp_logs_read:null,
    });


    useEffect(()=>{  
        if(user.id){
            setPermisos((prevPremisos) => ({
                ...prevPremisos,
                users_read:checkPermiso("users_read",user.permissions),
                doctors_read:checkPermiso("doctors_read",user.permissions),
                visits_read:checkPermiso("visits_read",user.permissions),
                employees_read:checkPermiso("employees_read",user.permissions),
                employee_vacations_history:checkPermiso("employee_vacations_history",user.permissions),
                appointment_models_list_read:checkPermiso("appointment_models_list_read",user.permissions),
                appointments_list_read:checkPermiso("appointments_list_read",user.permissions),
                products_read:checkPermiso("products_read",user.permissions),
                categories_read:checkPermiso("categories_read",user.permissions),
                sucursals_read:checkPermiso("sucursals_read",user.permissions),
                doctor_specialties_read:checkPermiso("doctor_specialties_read",user.permissions),
                doctor_institutions_read:checkPermiso("doctor_institutions_read",user.permissions),
                deliveries_read:checkPermiso("deliveries_read",user.permissions),
                suppliers_read:checkPermiso("suppliers_read",user.permissions),
                employee_types_read:checkPermiso("employee_types_read",user.permissions),
                configs_countries_module:checkPermiso("configs_countries_module",user.permissions),
                orders_read:checkPermiso("orders_read",user.permissions),
                orders_create:checkPermiso("orders_create",user.permissions),
                patient_read:checkPermiso("patient_read",user.permissions),
                whatsapp_logs_read:checkPermiso("whatsapp_logs_read",user.permissions),
                coupons_read:checkPermiso("coupons_read",user.permissions)
                //reportes_read:checkPermiso("reportes_read",user.permissions)
            }));
        }
    },[user])

   useEffect(()=>{
  
    if(permisos.users_read !== null){
        setRoutes([
            {
                path: "/dashboard",
                name: "Dashboard",
                icon: HomeIcon,
                iconColor:"#0033ff",
                layout: "/admin",
                visible: true, // Visible para todos los usuarios autenticados
                subRoutes:[]
            },
            {
                path: "/usuarios",
                name: "Usuarios",
                icon: UserPlusIcon,
                iconColor:"#5e72e4",
                layout: "/admin",
                visible:(permisos.users_read),
                subRoutes:[
                    {
                        path: "/usuarios",
                        name: "Usuarios",
                        icon: UserIcon,
                        iconColor:"#5e72e4",
                        visible:(permisos.users_read)
                    },
                    {
                        path: "/roles",
                        name: "Roles",
                        icon: IdentificationIcon,
                        iconColor:"#5e72e4",
                        visible:(permisos.users_read)
                    }
                ],
            },
            /*
            {
                path: "/doctores",
                name: "Doctores",
                icon: ShieldCheckIcon,
                iconColor:"#CC0000",
                layout: "/admin",
                visible:(permisos.doctors_read || permisos.visits_read),
                subRoutes:[
                    {
                        path: "/doctores",
                        name: "Doctores",
                        icon: UserGroupIcon,
                        iconColor:"#CC0000",
                        visible:(permisos.doctors_read)
                    },
                    {
                        path: "/visitas",
                        name: "Visitas Doctores",
                        icon: TruckIcon,
                        iconColor:"#CC0000",
                        visible:(permisos.visits_read)
                    },
                    {
                        path: "/calendario",
                        name: "Calendario visitas",
                        icon: CalendarDaysIcon,
                        iconColor:"#CC0000",
                        visible:(permisos.visits_read)
                    }
                ],
            },
            */
           /*
            {
                path: "/empleados",
                name: "Empleados",
                icon: ClipboardDocumentCheckIcon,
                iconColor:"#11CDEF",
                layout: "/admin",
                visible:(permisos.employees_read || permisos.employee_vacations_history),
                subRoutes:[
                    {
                        path: "/empleados",
                        name: "Empleados",
                        icon: UserGroupIcon,
                        iconColor:"#11CDEF",
                        visible:(permisos.employees_read)
                    },
                    {
                        path: "/empleados/vacaciones",
                        name: "Vacaciones",
                        icon: BriefcaseIcon,
                        iconColor:"#11CDEF",
                        visible:(permisos.employee_vacations_history)
                    }
                ],
            },
            */
            {
                path: "/agenda",
                name: "Agenda",
                icon: BookOpenIcon,
                iconColor:"#4CAF50 ",
                layout: "/admin",
                visible:(permisos.appointments_list_read || permisos.appointment_models_list_read),
                subRoutes:[
                    {
                        path: "/agenda",
                        name: "Agenda",
                        icon: CalendarDaysIcon,
                        iconColor:"#4CAF50 ",
                       visible:(permisos.appointments_list_read)
                    },
                    {
                        path: "/modelo-citas",
                        name: "Modelo de Citas",
                        icon: BookmarkSquareIcon,
                        iconColor:"#4CAF50 ",
                        visible:(permisos.appointment_models_list_read)
                    },
                    {
                        path: "/veragenda",
                        name: "Ver Agenda",
                        icon: CalendarIcon,
                        iconColor:"#4CAF50 ",
                        visible:(permisos.appointments_list_read)
                    },
                    {
                        path:"/festivos",
                        name:"Días Festivos",
                        icon:AcademicCapIcon,
                        iconColor:"#4CAF50 ",
                        visible:(permisos.appointments_list_read)
                    }
                ],
          
            },
            /*
            {
                path: "/pedidos",
                name: "Pedidos",
                icon: ShoppingCartIcon,
                iconColor:"#E3B778",
                layout: "/admin",
                visible:(permisos.orders_read||  permisos.orders_create || permisos.patient_read),
                subRoutes:[
                    
                    {
                        path: "/pedidos",
                        name: "Pedidos Principal",
                        icon: ShoppingCartIcon,
                        iconColor:"#E3B778",
                        visible:(permisos.orders_read)
                    },
                    {
                        path: "/nuevo-pedido",
                        name: "Hacer Pedido nuevo",
                        icon: PlusCircleIcon,
                        iconColor:"#E3B778",
                        visible:(permisos.orders_create)
                    },
                    {
                        path: "/clientes",
                        name: "Clientes",
                        icon: UsersIcon,
                        iconColor:"#E3B778",
                        visible:(permisos.patient_read)
                    },
                    
                    {
                        path: "/cupones",
                        name: "Cupones",
                        icon: TicketIcon,
                        iconColor:"#E3B778",
                        visible:(permisos.coupons_read)
                    }
                ],
            },
            */
            {
                path: "/servicios",
                name: "Servicios",
                icon: Squares2X2Icon,
                iconColor:"#1565C0",
                layout: "/admin",
                visible:(permisos.products_read || permisos.categories_read),
                subRoutes:[
                    {
                        path: "/servicios",
                        name: "Servicios",
                        icon: StarIcon,
                        iconColor:"#1565C0",
                        visible:(permisos.products_read)
                    },
                    {
                        path: "/categorias",
                        name: "Categorias",
                        icon: BookmarkIcon,
                        iconColor:"#1565C0",
                        visible:(permisos.categories_read)
                    },
                    {
                        path:"/categoriasweb",
                        name:"Categorias Web",
                        icon: Squares2X2Icon,
                        iconColor:"#1565C0",
                        visible:(permisos.products_read)
                    }
                ],
            },
            /*
            {
                path: "/reportes",
                name: "Reportes",
                icon: CalendarDaysIcon,
                iconColor:"#8c004b",
                layout: "/admin",
                visible:true,
                subRoutes:[
                    {
                        path: "/ingresos",
                        name: "Ingresos",
                        icon: CalendarIcon,
                        iconColor:"#800080",
                        visible:true
                    }
                ],
            },
            */
             {
                path: "/whatsapp/logs",
                name: "WhatsApp",
                icon: ChatBubbleBottomCenterTextIcon,
                iconColor:"#25D366",
                layout: "/admin",
                visible:(permisos.whatsapp_logs_read),
                subRoutes:[
                    {
                        path: "/whatsapp/logs",
                        name: "Bitácora Webhooks",
                        icon: ClipboardDocumentListIcon,
                        iconColor:"#25D366",
                        visible:(permisos.whatsapp_logs_read)
                    },
                    {
                        path: "/whatsapp/chat",
                        name: "Chat",
                        icon: ChatBubbleBottomCenterTextIcon,
                        iconColor:"#25D366",
                        visible:(permisos.whatsapp_logs_read)
                    }
                ],
            },
            {
                path: "/catalogos",
                name: "Catalogos",
                icon: DocumentTextIcon,
                iconColor:"#FF6347",
                layout: "/admin",
                visible:(permisos.sucursals_read || permisos.doctor_specialties_read || permisos.doctor_institutions_read || permisos.deliveries_read || permisos.deliveries_read || permisos.employee_types_read),
                subRoutes:[
                    {
                        path: "/sucursales",
                        name: "Sucursales",
                        icon: BuildingOffice2Icon,
                        iconColor:"#FF6347",
                        visible:(permisos.sucursals_read)
                    },
                    /*
                    {
                        path: "/especialidades",
                        name: "Medicos Especialidad",
                        icon: ClipboardDocumentListIcon,
                        iconColor:"#FF6347",
                        visible:(permisos.doctor_specialties_read)
                    },
                    */
                    /*
                    {
                        path: "/instituciones",
                        name: "Instituciones",
                        icon: BuildingOffice2Icon,
                        iconColor:"#FF6347",
                        visible:(permisos.doctor_institutions_read)
                    },
                    */
                   /*
                    {
                        path: "/paqueteria",
                        name: "Paqueteria",
                        icon: TruckIcon,
                        iconColor:"#FF6347",
                        visible:(permisos.deliveries_read)
                    }, 
                    */
                    /*
                    {
                        path: "/proveedores",
                        name: "Proveedores",
                        icon: DocumentDuplicateIcon,
                        iconColor:"#FF6347",
                        visible:(permisos.deliveries_read)
                    },
                    */
                    /*
                    {
                        path: "/tipoempleados",
                        name: "Tipo Empleados",
                        icon: UserGroupIcon,
                        iconColor:"#FF6347",
                        visible:(permisos.employee_types_read)
                    }
                    */
                ],
            },
            /*
            {
                path: "/configuracion",
                name: "Configuraciones",
                icon: Cog6ToothIcon,
                iconColor:"#2DCE89",
                layout: "/admin",
                visible:(permisos.configs_countries_module),
                subRoutes:[
                    {
                        path: "/paises",
                        name: "Paises",
                        icon: FlagIcon,
                        iconColor:"#2DCE89",
                        visible:(permisos.configs_countries_module)
                    }
                ],
            }
            */
        ]);
    }
   },[permisos]);

   useEffect(()=>{ 
    if(routes.length > 0){
        setLoaded(true)
    }
   },[routes])

    const changeWhith=(e)=>{
        e.preventDefault();
        if(!colapsed){
            setWMenuLateral('5%')
            setWContainerAdmin('100%')
            setColapsed(true)
        }
        else{
            setWMenuLateral('15%')
            setWContainerAdmin('100%')
            setColapsed(false)
        }
    }

    const _renderLogout = ()=>{
        return(
            <>
                <hr className="my-2 border-gray-200 shadow-lg" />
                <div className="p-0 m-0">
                    <button 
                        onClick={_logout}
                        className="flex items-center w-full px-2 py-3 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        <ArrowRightStartOnRectangleIcon className="w-6 h-6 text-black" style={{width: !colapsed ? '20%' : '60%'}} />
                        {!colapsed && <span className="uppercase text-base font-semibold leading-none pt-2">Cerrar Sesion</span>}
                    </button>
                </div>
                <hr className="my-2 border-gray-200 shadow-lg" />
            </>
           
        )
    }

    const _logout = () => {
        console.log("Cerrando sesion...")
        axios.delete('api/logout').then(resp=>{
            console.log("deslogear",resp);
            setUser({});
            setAuth(false);
            localStorage.removeItem("access_token");
            navigate("/")
        }).catch(e=>console.log("Error: ",e))
    }

    /**
     * 
     * @param {*} route ruta principal para renderizar el accordion parent
     * @param {*} subRoute subruta para renderizar el sub menu del acordion
     * @returns elemento del submenu
     */
    const renderSubMenu = (route, subRoute, i, closeModal = false) => {
        const IconComponent = subRoute.icon;
        return (
            <li key={i} className="block w-full m-0 pl-12 hover:bg-[#e0f7fa] hover:rounded transition-colors">
                <Link 
                    to={route.layout + subRoute.path} 
                    className="flex items-center py-8 px-2 m-0 text-[#0033ff] w-full"
                    onClick={closeModal ? () => setMobileMenuOpen(false) : undefined}
                >
                    <IconComponent className="w-5 h-5 m-0 p-0 inline-block align-middle" style={{color: subRoute.iconColor}} />
                    {!colapsed && <span className="text-[14px] text-shadow-sm font-semibold leading-tight pl-3 text-gray-500">{subRoute.name}</span>}
                    
                </Link>
            </li>
        )
    }

    return (
        <div className="m-0 p-0 h-full" style={{width: colapsed}}>
            {/* Menú móvil - Botón */}
            <div className="md:hidden">
                <button 
                    className="flex items-center justify-center bg-[#0033ff] text-white rounded-md p-0 m-0"
                    style={{width: '36px', height: '36px'}}
                    onClick={() => setMobileMenuOpen(true)}
                >
                    <Bars3Icon className="w-6 h-6"/>
                </button>

                {/* Dialog móvil con Headless UI */}
                <Transition show={mobileMenuOpen} as={Fragment}>
                    <Dialog onClose={() => setMobileMenuOpen(false)} className="relative z-[100]">
                        <TransitionChild
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black/30" />
                        </TransitionChild>

                        <div className="fixed inset-0 overflow-y-auto">
                            <TransitionChild
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <DialogPanel className="fixed inset-0 bg-white overflow-y-auto">
                                    <div className="flex justify-center items-center relative pt-4">
                                        <img className="h-[100px]" src="/images/logo.png" alt="dento metric" />
                                        <button 
                                            onClick={() => setMobileMenuOpen(false)}
                                            className="absolute right-4 top-4 w-8 h-8 flex items-center justify-center text-gray-600 hover:text-gray-900"
                                        >
                                            <XMarkIcon className="w-6 h-6" />
                                        </button>
                                    </div>
                                    <nav className="p-4">
                                        {routes.map((route, index) =>
                                            route.visible && (
                                                <Fragment key={index}>
                                                    {index > 0 && <hr className="my-2 border-gray-200 shadow-lg" />}
                                                    <Disclosure>
                                                        {({ open }) => (
                                                            <div className={`mb-1 rounded-lg transition-colors ${open ? 'bg-[#e0f7fa]' : ''}`}>
                                                            {route.subRoutes.length === 0 ? (
                                                                <Link 
                                                                    to={route.layout + route.path}
                                                                    onClick={() => setMobileMenuOpen(false)}
                                                                    className="flex items-center w-full px-2 py-2 text-gray-600 border border-transparent hover:bg-[#e0f7fa] rounded-lg"
                                                                >
                                                                    <route.icon className="w-6 h-6" style={{color: route.iconColor}} />
                                                                    <span className="ml-2 uppercase text-xs font-extrabold text-shadow-sm">{route.name}</span>
                                                                </Link>
                                                            ) : (
                                                                <>
                                                                    <DisclosureButton  className={`flex items-center justify-between w-full px-2 py-2 text-gray-600 border border-transparent rounded-lg ${open ? '' : 'hover:bg-[#e0f7fa]'}`}>
                                                                        <div className="flex items-center">
                                                                            <route.icon className="w-6 h-6" style={{color: route.iconColor}} />
                                                                            <span className="ml-2 uppercase text-xs font-extrabold">{route.name}</span>
                                                                        </div>
                                                                        <ChevronDownIcon className={`w-5 h-5 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
                                                                    </DisclosureButton >
                                                                    <DisclosurePanel className="pl-3">
                                                                        <ul className="flex flex-col m-0 p-0 py-1 list-none">
                                                                            {route.subRoutes.map((sub, i) =>
                                                                                sub.visible && renderSubMenu(route, sub, i, true)
                                                                            )}
                                                                        </ul>
                                                                    </DisclosurePanel>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </Disclosure>
                                            </Fragment>
                                            )
                                        )}
                                        {_renderLogout()}
                                    </nav>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </Dialog>
                </Transition>
            </div>

            {/* Menú desktop */}
            <div className="max-md:hidden">
                <div className="bg-white h-screen w-full overflow-y-auto overflow-x-hidden shadow-[10px_0px_25px_-12px_rgba(0,51,255,0.8)] menu-scrollbar m-0 p-0">
                    {/* Botón colapsar */}
                    <div className="pt-2.5 absolute z-[9999]" style={{left: !colapsed ? '82%' : '50%'}}>
                        <a 
                            href="#!" 
                            onClick={(e) => changeWhith(e)} 
                            className="flex items-center justify-center bg-[deepskyblue] rounded-md w-[25px] h-[25px] m-0 p-0 size-7"
                        >
                            {!colapsed ? (
                                <Bars3Icon className="w-7 h-7  text-[#0033ff] hover:w-6 hover:h-6 transition-all" />
                            ) : (
                                <Bars3BottomLeftIcon className="w-7 h-7  text-[#0033ff] hover:w-6 hover:h-6 transition-all" />
                            )}
                        </a>
                    </div>

                    {/* Logo */}
                    <div className="flex justify-center items-center py-5">
                        <img 
                            className="transition-all duration-300" 
                            src="/images/logo.png" 
                            alt="dento metric" 
                            style={{height: !colapsed ? '100px' : '34px'}} 
                        />
                    </div>
                    
                    {/* Navegación */}
                    <nav className="p-2.5">
                        {routes.map((route, index) =>
                            route.visible && (
                                <Fragment key={index}>
                                    {index > 0 && <hr className="my-2 border-gray-200 shadow-lg" />}
                                    <Disclosure>
                                        {({ open }) => (
                                            <div className={`mb-1 rounded-lg transition-colors ${open ? 'bg-[#e0f7fa]' : ''}`}>
                                            {route.subRoutes.length === 0 ? (
                                                <Link 
                                                    to={route.layout + route.path}
                                                    className="flex items-center w-full px-2 py-2 text-gray-600 border border-transparent hover:bg-[#e0f7fa] rounded-lg"
                                                >
                                                    <route.icon className="w-6 h-6 m-0 p-0 inline-block align-middle" style={{width: !colapsed ? '20%' : '60%', color: route.iconColor}} />
                                                    {!colapsed && <span className="inline-block align-middle text-left uppercase text-base font-semibold leading-none pt-2" style={{width: !colapsed ? '72%' : '1px'}}>{route.name}</span>}
                                                </Link>
                                            ) : (
                                                <>
                                                    <DisclosureButton className={`flex items-center w-full h-15 p-2.5 text-gray-600 border border-transparent rounded-lg ${open ? '' : 'hover:bg-[#e0f7fa]'}`}>
                                                        <route.icon className="w-6 h-6 m-0 p-0 inline-block align-middle" style={{width: !colapsed ? '20%' : '60%', color: route.iconColor}} />
                                                        {!colapsed && <span className="inline-block align-middle text-left uppercase text-base font-semibold leading-none pt-2" style={{width: !colapsed ? '72%' : '1px'}}>{route.name}</span>}
                                                        <div className="flex items-start" style={{width: !colapsed ? '8%' : '40%'}}>
                                                            <ChevronDownIcon className={`w-5 h-5 m-0 p-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
                                                        </div>
                                                    </DisclosureButton >
                                                    <DisclosurePanel className="m-0 p-0">
                                                        <ul className="flex flex-col m-0 p-0 py-1 list-none">
                                                            {route.subRoutes.map((sub, i) =>
                                                                sub.visible && renderSubMenu(route, sub, i)
                                                            )}
                                                        </ul>
                                                    </DisclosurePanel>
                                                </>
                                            )}
                                        </div>
                                    )}
                                </Disclosure>
                                </Fragment>
                            )
                        )}
                        {_renderLogout()}
                    </nav>
                </div> 
            </div>       
        </div>
    );
};

export default MenuLeft;